import { helpers } 		from './theme/helpers.js';
import { hamburger } 	from './theme/components/hamburger.js';
// import { modal } 		from './theme/components/modal.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
	},
	init: function () {
		var self = this;

		// Global
		self.smoothScroll.init();
		self.onloadClass();

		// self.loadFancy();
		self.touch();
		self.button();
		self.formsReplace();
		self.typo();
		
		// modal.init();
		hamburger.init();
	},

	formsReplace: function() {
		
		if( jQuery( '.wpdev-form-control-wrap' ).length ) {
			jQuery( '.wpdev-form-control-wrap input[type="text"]' ).each( function() {
				var input 			= jQuery( this );
				var inputName 		= input.attr( 'name' );

				if( inputName.includes( 'name' ) ) {
					input.attr( 'autocomplete', 'name' );
					return;
				}

				if( inputName.includes( 'email' ) ) {
					input.attr( 'autocomplete', 'email' );
					return;
				}

				if( inputName.includes( 'phone' ) ) {
					input.attr( 'autocomplete', 'tel' );
					return;
				}
			});
		}
		
	},

	typo: function() {
		jQuery( 'h1, h2, h3, p' ).each(function(){
			var currentNode = jQuery(this);

			var rules = [
				[/  /g, " "],
				[/ (a|i|o|u|s|z|k|v|A|I|O|U|S|Z|K|V) /g, " $1\u00a0"],
				[/ (a|i|o|u|s|z|k|v|A|I|O|U|S|Z|K|V)\uE000 /g, " $1\u00a0\uE000"],
				[/ \uE000(a|i|o|u|s|z|k|v|A|I|O|U|S|Z|K|V)\uE000 /g, " \uE000$1\u00a0\uE000"],
				[/ \uE000(a|i|o|u|s|z|k|v|A|I|O|U|S|Z|K|V) /g, " \uE000$1\u00a0"],
				[/([§|#])( )(\d)/g, "$1"+"\u00a0"+"$3"],
				[/([§|#])(| )\uE000(| )(\d)/g, "$1"+"\u00a0\uE000"+"$4"],
				[/(tj|tzv|tzn)\. /g, "$1.\u00a0"]
			];

			for( let rule of rules ) {
				currentNode.html( currentNode.html().replace( rule[0], rule[1] ) );
			}
		});
	},

	button: function() {
		if( ! jQuery('input.button--form').length ) {
			return false;
		}

		var oSubmitButton = jQuery('input.button--form');
        var oForm = oSubmitButton.closest('form');
        var sOriginAttrs = '';
		var text = '';

        jQuery.each(oSubmitButton[0].attributes, function() {
            if (this.specified) {
                sOriginAttrs += ' ' + this.name + '="' + this.value + '"';

				if( this.name == 'value' ) {
					text = this.value;
				}
			}
        });

        oSubmitButton.replaceWith( jQuery('<button ' + sOriginAttrs + '>').text( text ).click(function(event) {
            event.preventDefault();
        }));
	},

	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},

	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},
	
	smoothScroll: {
		selector: 'a[href*="#"]:not([href="#"])',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: 0,
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},

	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},
	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},
	onresize() {
		var self = this;
	},
	onscroll(position, previusPosition) {
		var self = this;

		if(  self.windowPosition()[ 'y' ] >= 100 ) {
			jQuery( '.back-to-top' ).addClass( 'view' );
		} else {
			jQuery( '.back-to-top' ).removeClass( 'view' );
		}
	},
};

jQuery(document).ready(function ($) {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
}; 

jQuery.fn.isOnScreen = function(){
    var win = jQuery(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};